import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createContext, useContext } from 'react';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri, HelpPageAri } from '@atlassian/ari/help';
export var getAuthProvider = function getAuthProvider(asapIssuer, mediaToken, mediaUrl) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", {
            asapIssuer: asapIssuer,
            token: mediaToken,
            baseUrl: mediaUrl
          });
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
export var getMediaProvider = function getMediaProvider(mediaCollectionName, asapIssuer, mediaToken, mediaUrl) {
  return {
    uploadParams: {
      collection: mediaCollectionName
    },
    viewMediaClientConfig: {
      authProvider: getAuthProvider(asapIssuer, mediaToken, mediaUrl),
      useSha256ForUploads: true
    }
  };
};
var getSafeHelpCenterIdMeta = function getSafeHelpCenterIdMeta(helpCenterAri) {
  try {
    if (helpCenterAri && helpCenterAri !== 'null') {
      var _HelpHelpCenterAri$pa = HelpHelpCenterAri.parse(helpCenterAri),
        activationId = _HelpHelpCenterAri$pa.activationId,
        helpCenterId = _HelpHelpCenterAri$pa.helpCenterId;
      return {
        activationId: activationId,
        helpCenterId: helpCenterId
      };
    }
  } catch (error) {
    // todo: add analytics
  }
};
export var getPageAri = function getPageAri(helpCenterAri, pageId) {
  var _ref2 = getSafeHelpCenterIdMeta(helpCenterAri) || {},
    _ref2$activationId = _ref2.activationId,
    activationId = _ref2$activationId === void 0 ? '' : _ref2$activationId,
    _ref2$helpCenterId = _ref2.helpCenterId,
    helpCenterId = _ref2$helpCenterId === void 0 ? '' : _ref2$helpCenterId;
  return HelpPageAri.create({
    activationId: activationId,
    pageId: pageId || helpCenterId
  }).toString() || '';
};
export var HubContext = /*#__PURE__*/createContext(null);
export var useHubContext = function useHubContext() {
  var context = useContext(HubContext);
  if (!context) {
    throw new Error('useHubContext must be used within a HubContextProvider');
  }
  return context;
};